export default __webpack_public_path__ + "static/media/loader_spinner.19c6ac69.gif";